/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Station_Work_Countdown_MinutesInputs */

const vi_station_work_countdown_minutes = /** @type {(inputs: Station_Work_Countdown_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn ${i?.minutes} phút`)
};

/**

* @param {Station_Work_Countdown_MinutesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_countdown_minutes = /** @type {((inputs: Station_Work_Countdown_MinutesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Countdown_MinutesInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_countdown_minutes(inputs)
});